export enum DokumentenVerteilungVariables {
  'document' = 'document',
  'documentDistribution' = 'documentDistribution',
  'dokumentenverteilungverteilungalleablagebokudms' = 'dokumentenverteilungverteilungalleablagebokudms'
}

export const DokumentenVerteilungVariablesSearchable = []
